import type { LearnerSearchResultItem, SearchResultItem } from '../../types';

export const getLearnerSearchResultItemFromAlgoliaHit = (resultItem: SearchResultItem): LearnerSearchResultItem => {
  const lastUpdatedDateTime = new Date(resultItem.updatedDate).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  if (resultItem.type === 'guide_section' || resultItem.type === 'guide_task') {
    return {
      id: resultItem.id,
      type: resultItem.type,
      resultTitle: resultItem.guide.name,
      resultSubtitle: resultItem.snippetMatch?.title || resultItem.name,
      lastUpdated: lastUpdatedDateTime,
      textValue: resultItem.name,
    };
  }

  if (resultItem.type === 'content_provider_content') {
    return {
      id: resultItem.id,
      type: resultItem.type,
      contentSource: resultItem?.contentSource,
      resultTitle: resultItem.snippetMatch?.title || resultItem.name,
      resultSubtitle: null,
      lastUpdated: lastUpdatedDateTime,
      textValue: resultItem.name,
    };
  }

  return {
    id: resultItem.id,
    type: resultItem.type,
    resultTitle: resultItem.snippetMatch?.title || resultItem.name,
    resultSubtitle: null,
    lastUpdated: lastUpdatedDateTime,
    textValue: resultItem.name,
  };
};
